module.exports = __webpack_public_path__ + "static/img/3c.6aff11e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/3c.jpg
// module id = 2CE+
// module chunks = 1